import { QueryResult, useQuery } from '@apollo/client';
import React, { createContext } from 'react';
import {
  Configuration,
  CONFIGURATION_TYPE,
  getConfigurations,
} from 'vendor-marketplace-shared-library';

import useAlert from '../hooks/useAlert';
import useAuth from '../hooks/useAuth';
import { getConfigurationValue } from './helpers';

export interface ConfigurationsContextParams {
  configurationsQuery: QueryResult;
}

export const ConfigurationsContext = createContext({} as ConfigurationsContextParams);

export default function ConfigurationsProvider(props: { children: React.ReactNode }) {
  const { setAlert } = useAlert();
  const { accessToken } = useAuth();

  const configurationsQuery = useQuery(getConfigurations, {
    pollInterval: 60000, // 60 seconds
    notifyOnNetworkStatusChange: true,
    skip: !accessToken,
    onCompleted: data => {
      const globalAppMessageConfiguration = data?.getConfigurations?.find(
        (configuration: Configuration) =>
          configuration.name === CONFIGURATION_TYPE.GLOBAL_APP_MESSAGE,
      );
      const globalAppMessageConfigurationValue = getConfigurationValue(
        globalAppMessageConfiguration,
      );
      if (globalAppMessageConfigurationValue) {
        setAlert({
          message: globalAppMessageConfigurationValue,
          duration: 30000, // 30 seconds
          dismissible: true,
        });
      }
    },
  });

  return (
    <ConfigurationsContext.Provider value={{ configurationsQuery }}>
      {props.children}
    </ConfigurationsContext.Provider>
  );
}
